import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import { Link } from 'react-router-dom'
import { Button, Breadcrumb, Loading, Alert } from 'element-react'
import { tagHotjarRecording, createValidator } from '../../helpers/util'
import { UnlabeledInputField, CustomCheckbox } from '../../helpers/fieldHelper'
import Spacer from '../../components/views/includes/Spacer'
import { MainSection, Section } from '../../components/views/includes/Wrappers'
import ErrorAlert from '../../components/views/includes/ErrorAlert'
import useAuth from '../../hooks/useAuth'
import AppRoutes from '../../routes/appRoutes'

const validate = createValidator(['firstName', 'lastName', 'email'])

const CreateAdminPage = props => {
    const Status = {
        READY: 'Ready',
        LOADING: 'Loading',
        SUCCEEDED: 'Succeeded',
        ERRORED: 'Errored',
    }
    const [formStatus, setFormStatus] = useState(Status.READY)
    const [error, setError] = useState('')
    const { addNewAdminUser } = useAuth()

    const {
        history: { goBack },
    } = props

    const onAddAdminUser = () => {
        setError('')
        setFormStatus(Status.SUCCEEDED)
    }

    const onErrorAddADminUser = err => {
        tagHotjarRecording('API Error')
        let errs = err.response.data.errors
        let message = err.response.data.message
        if (errs) {
            if (errs.email && errs.email[0].length > 0) {
                setError(errs.email[0])
            } else if (errs.firstName && errs.firstName[0].length > 0) {
                setError(errs.firstName[0])
            } else if (errs.lastName[0].length > 0) {
                setError(errs.lastName[0])
            }
        } else {
            setError(message)
        }
        setFormStatus(Status.ERRORED)
    }

    const onSubmit = adminInfo => {
        setError('')
        setFormStatus(Status.LOADING)

        addNewAdminUser(adminInfo, onAddAdminUser, onErrorAddADminUser)
    }

    return (
        <MainSection className="admin--add-user">
            <div className="row">
                <div className="columns medium-9">
                    <Breadcrumb separator="/" className="margin-top-small">
                        <Breadcrumb.Item>
                            <Link to={AppRoutes.home()}>Home</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Create Admin</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="columns medium-3 show-for-medium">
                    <Button
                        type="text"
                        onClick={goBack}
                        className="button-back margin-top-small"
                    >
                        <i className="icon-chevron-thin-left"></i> Go Back
                    </Button>
                </div>
            </div>

            <Section>
                <Spacer size="small" />
                {formStatus === Status.ERRORED && <ErrorAlert error={error} />}
                {formStatus === Status.SUCCEEDED && (
                    <Alert
                        showIcon={true}
                        className="margin-bottom-small"
                        description="A new admin account has been created."
                        title="Success"
                        type="success"
                        closable={true}
                    />
                )}
                Create Admin
                <Form validate={validate} onSubmit={onSubmit}>
                    {({ handleSubmit, pristine, submitting }) => (
                        <form id="addAdminForm" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="columns medium-6">
                                    <Field
                                        label="First Name"
                                        name="firstName"
                                        component={UnlabeledInputField}
                                        id="firstName"
                                        type="text"
                                    />
                                </div>
                                <div className="columns medium-6">
                                    <Field
                                        label="Last Name"
                                        name="lastName"
                                        component={UnlabeledInputField}
                                        id="lastName"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="columns medium-6">
                                    <Field
                                        label="Email Address"
                                        name="email"
                                        component={UnlabeledInputField}
                                        id="email"
                                        type="text"
                                    />
                                </div>
                                <div className="columns medium-6">
                                    <Field
                                        label="This Admin is a Salesperson"
                                        name="isSalesperson"
                                        id="isSalesperson"
                                        component={CustomCheckbox}
                                        type="checkbox"
                                        initialValue={true}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="columns medium-6 medium-push-6">
                                    <div className="row">
                                        <div className="columns medium-6">
                                            {/* Create Button */}
                                            {formStatus === Status.LOADING ? (
                                                <div className="demo-loading padding-top-large padding-bottom-large">
                                                    {' '}
                                                    <Loading text="Saving..." />
                                                </div>
                                            ) : (
                                                <Button
                                                    nativeType="submit"
                                                    type="primary"
                                                    className="expanded"
                                                    disabled={
                                                        pristine || submitting
                                                    }
                                                >
                                                    Create
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Form>
            </Section>
        </MainSection>
    )
}

CreateAdminPage.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired,
    }),
}

export default CreateAdminPage
